const { defaultSlickResponsive } = require("./slick-params")

var block_team = {
  ui: {},

  init: function () {
    this.bindUI()
    this.bindEvents()

    this.initSlider()
  },

  bindUI: function () {
    this.ui.$slider = $('.js-team-list')
  },

  bindEvents: function () {
    // this.ui.$slick.on('ready', this.mediaToCarousel.bind(this));
  },

  initSlider: function () {
    
    this.ui.$slider.slick({
      
      ...defaultSlickResponsive,
      prevArrow: '<button type="button" class="slick-prev"><svg class="icon icon-caret"><use xlink:href="#icon-caret"></use></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg class="icon icon-caret"><use xlink:href="#icon-caret"></use></svg></button>',
      centerMode: false,
      dots: true,
      
    })
  },
}

module.exports = block_team

// export default class BlockTeam {
//   constructor(el) {
//     console.log('BLOCKTEAM', el)
//     this.current = 0

//     this.el = el

//     this.btPrev = el.querySelector('.js-team-btprev')
//     this.btNext = el.querySelector('.js-team-btnext')
//     this.pagin = el.querySelector('.js-team-pagin')
//     this.list = el.querySelector('.js-team-list')
//     this.items = el.querySelectorAll('.js-team-item')

//     this.total = this.items.length
//     this.updateSizeParams()

//     window.addEventListener('resize', ()=>{
//       this.updateSizeParams()
//     })

//     if (this.btPrev) {
//       this.btPrev.addEventListener('click', () => {
//         if (this.current > 0) {
//           this.current--
//           this.update()
//         }
//       })
//     }
//     if (this.btNext) {
//       this.btNext.addEventListener('click', () => {
//         if (this.current < this.max) {
//           this.current++
//           this.update()
//         }
//       })
//     }

//     this.update()
//   }

//   update() {
//     this.items.forEach((item, index) => {
//       let o
//       if (this.current <= index && this.current + 3 > index) {
//         o = 1
//       } else {
//         o = 0
//       }
//       item.style.opacity = o
//       item.style.transform = `translate3d(${-this.current * 100}%, 0, 0)`
//     })

//     if (this.pagin) {
//       const scalePagin = this.nb / this.total
//       const translatePagin = (1 / this.total) * 100 * this.current
//       this.pagin.style.transform = `translateX(${translatePagin}%) scaleX(${scalePagin})`
//     }
//   }

//   updateSizeParams(){
//     this.max = this.total - 1
//     this.nb = 1

//     if (document.documentElement.clientWidth > 500) { // mq mobile
//       this.nb = 3
//       this.max -= 2
//     }

//     console.log('NB', this.nb)
//     console.log('MAX', this.max)
//     console.log('TOTAL', this.total)

//     this.update()
//   }
// }
